import o from "react-cookies";
import n from "jwt-decode";
var e = "5AJWT_AUTH";
function t(o) {
  var n;
  return "undefined" != typeof window ? (null === (n = document.cookie) || void 0 === n ? void 0 : n.indexOf(e)) >= 0 : !!(null == o ? void 0 : o.headers) && o.headers.cookie && o.headers.cookie.indexOf(e) >= 0;
}
function i() {
  return o.load("auth_mode");
}
function a(o, n, e) {
  document.cookie = "".concat(o, "=;expires=Thu,01-Jan-70 00:00:01 GMT;domain=").concat(n, ";path=").concat(e);
}
function c(o) {
  document.cookie.split("; ").forEach(function (n) {
    a(n.split("=")[0], o, "/");
  });
}
function d(o) {
  var n = o;
  return n = n.replace(/^www\./i, ""), n;
}
function r(o) {
  var n;
  return null === (n = o.match(/((quintoandar.|full.|inmuebles24.|5adev.|dev.|forno.|staging.)*?\w+.\w+)$/g)) || void 0 === n ? void 0 : n.toString();
}
function u() {
  return process.env.COOKIE_DOMAIN ? ".".concat(d(process.env.COOKIE_DOMAIN)) : ".".concat(r(window.location.hostname));
}
function s() {
  var t = o.load(e);
  var i = null;
  if (t) try {
    i = n(t);
  } catch (o) {
    i = null;
  }
  return i;
}
var l = function l(n) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    return o.load(n, e);
  },
  m = function m(n, e, t) {
    var i = t && t.domain || "",
      a = t && t.path || "/",
      c = t && t.maxAge || 1800;
    var d = !0;
    i.includes(".dev.quintoandar.com.br") && (d = !1), o.save(n, e, {
      path: a,
      maxAge: c,
      domain: i,
      secure: d
    });
  },
  f = function f(o, n, e) {
    var t = e || {};
    t.domain = ".".concat(window.location.host), m(o, n, t);
  },
  p = function p(o, n, e) {
    var t = e || {};
    t.domain = window.location.host.replace(/^.*?((forno|dev|staging)\.)?(quintoandar.com.br)$/g, ".$1$3"), m(o, n, t);
  };
export { a as clearCookie, c as clearListCookies, d as extractDomainName, r as extractDomainNameWithoutSubdomain, l as getCookie, u as getCookieDomain, t as hasAuthCookie, i as parseAuthMode, s as parseCookiesToUser, m as setCookie, f as setCookieOnAppDomain, p as setCookieOnBaseDomain };
